(function () {
    "use strict";

    angular
        .module('harriApp')
        .controller("WageMatrixFailedProspectsModalController", WageMatrixFailedProspectsModalController);

    WageMatrixFailedProspectsModalController.$inject = ["$scope", "modalData", "onClose"];

    function WageMatrixFailedProspectsModalController ($scope, modalData, onClose) {
        const self = this;

        const init = () => {
            self.prospectsDetails = modalData.prospectsDetails;
        }
        init();

        self.close = () => {
            onClose();
            $scope.$hide();
        };
    }
})();